import React from 'react';
import styles from './DropdownEmpty.module.sass';

const DropdownEmpty = () => {
    return <div className={styles['dropdown__empty']}>
        Geen resultaten gevonden...
    </div>
}

export default React.memo(DropdownEmpty);